
<div class="customer-buy">

  <div>
    @switch (transactionStages[0]) {
      @case (TransactionStage.DRAFT) {
        <h1>Prospects ({{ (myBuyCars$  | async)?.length}})</h1>
      }
      @case (TransactionStage.CONFIRMED) {
        <h1>Mes prospects ({{ (myBuyCars$  | async)?.length}})</h1>
      }
      @case (TransactionStage.ONGOING) {
        <h1>Ventes en cours ({{ (myBuyCars$  | async)?.length}})</h1>
      }
      @case (TransactionStage.COMPLETED) {
        <h1>Ventes complétées ({{ (myBuyCars$  | async)?.length}})</h1>
      }
    }
  </div>

  <div class="favorites">

    <div class="buttons-section">
      <!--
      <button mat-button (click)="openCarEditDialog()" class="btn btn-default"><mat-icon>add</mat-icon>Ajouter une voiture</button>
      -->
    </div>
    <!--
    <div class="cars-section" *ngIf = "((myFavoriteCars$  | async) != undefined )">
      <div *ngFor="let car of (myFavoriteCars$  | async)!; index as i" id="{{car.carId}}" class="car-section">

        <app-car-card-buyer
          [car]="car"

          [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!">
        </app-car-card-buyer>
      </div>
    </div> -->

    @if (((myBuyCars$ | async) == undefined ) || (myBuyCars$ | async)!.length === 0 ) {
      <h6>
        <br />
        Aucun véhicule à vendre
      </h6>
    }

    @if (((myBuyCars$  | async) != undefined )) {
      <div class="cars-section">
        @for (car of (myBuyCars$  | async)!; track car; let i = $index) {
          <div id="{{car.carId}}" class="car-section">
            <app-provider-offer-card-seller
              [offer]="car"
              [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!"
              [objectSource]="objectSource"
              >
            </app-provider-offer-card-seller>
          </div>
        }
      </div>
    }
  </div>
</div>

